import { render, staticRenderFns } from "./exhibitionSoftware.vue?vue&type=template&id=5b2a0b5c&scoped=true&"
import script from "./exhibitionSoftware.vue?vue&type=script&lang=js&"
export * from "./exhibitionSoftware.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionSoftware.vue?vue&type=style&index=0&id=5b2a0b5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a0b5c",
  null
  
)

export default component.exports